export default __webpack_public_path__ + "static/media/slide2.b781c2ce.jpg";